import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Condition {
    condition: string;
    value: any;
    id: any;
}

export interface PageFilterState {
    showFilter: boolean;
    selectedConditions: Condition[];
    selectedDepartmentIndex? :number
    departmentList? :number
}

export interface FilterState {
    [page: string]: PageFilterState;
}

const initialState: FilterState = {};

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        toggleFilter: (state, action: PayloadAction<{ page: string }>) => {
            const { page } = action.payload;
            if (!state[page]) {
                state[page] = { showFilter: false, selectedConditions: [] };
            }
            state[page].showFilter = !state[page].showFilter;
            state[page].selectedConditions = state[page]?.selectedConditions ?? [];
        },
        addCondition: (state, action: PayloadAction<{ page: string, condition: string, value: any[], id: any[] }>) => {
            const { page, condition, value, id } = action.payload;
            if (!state[page]) {
                state[page] = { showFilter: false, selectedConditions: [] };
            }
            const existingConditionIndex = state[page]?.selectedConditions?.findIndex(cond => cond?.condition === condition);
            if (existingConditionIndex >= 0) {
                state[page].selectedConditions[existingConditionIndex].value = value;
                state[page].selectedConditions[existingConditionIndex].id = id;
            } else {
                state[page]?.selectedConditions?.push({ condition, value, id });
            }
        },
        removeCondition: (state, action: PayloadAction<{ page: string, condition: string | any }>) => {
            const { page, condition } = action.payload;
            if (state[page]) {

                // Clear related conditions
                if (condition === 'Company') {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond.condition !== 'Company' && cond.condition !== 'Department' && cond.condition !== 'Job' && cond.condition !== 'Branch'
                    );
                } else if (condition === 'Department') {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond.condition !== 'Department'
                    );
                } else if (condition === 'Branch') {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond.condition !== 'Branch'
                    )
                } else if (condition === 'Created By') {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond.condition !== 'Created By'
                    )
                } else if (condition === 'Hiring Manager') {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond.condition !== 'Hiring Manager'
                    )
                } else if (condition === 'companyChange') {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond?.condition !== 'Department' && cond?.condition !== 'Job' && cond?.condition !== 'Branch' && cond?.condition !== 'Created By' && cond?.condition !== 'Hiring Manager'
                    );
                }
                else {
                    state[page].selectedConditions = state[page]?.selectedConditions?.filter(
                        cond => cond?.condition !== 'Job'
                    );
                }
            }
        },
        clearConditions: (state, action: PayloadAction<{ page: string, condition: string | any }>) => {
            const { page } = action.payload;
            if (state[page]) {
                state[page].selectedConditions = state[page].selectedConditions.filter(
                    cond => cond.condition !== 'Company' && cond.condition !== 'Department' && cond.condition !== 'Job' && cond.condition !== 'Branch' && cond.condition !== 'Created By' && cond.condition !== 'Hiring Manager'
                );
            }
        },
        inputSerachBy: (state, action) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { toggleFilter, addCondition, removeCondition, clearConditions, inputSerachBy } = filterSlice.actions;
export default filterSlice.reducer;
